import gql from 'graphql-tag';

import { ClaimViewFields } from './fragments/claim';

export const CreateClaim = gql`
  mutation CreateClaim($input: GSTCreateClaimRequestInput!) {
    createClaim(input: $input) {
      result
      errorCode
      reasons
      claim {
        ...ClaimViewFields
      }
    }
  }
  ${ClaimViewFields}
`;
